<template>
  <div class="divider"></div>
</template>

<style scoped lang="scss">
.divider {
  height: 0;
  width: 100%;
  box-shadow: 0 0 0 0.5px $colour-border-mid;
  opacity: 0.5;
  &.before {
    margin-top: 0.5rem;
  }
  &.between {
    margin: 0.5rem 0;
  }
  &.after {
    margin-bottom: 0.5rem;
  }
}
</style>
